import React from 'react';

const AllwynTheme = {
  headerLogo: {
    src: '/themes/theme/allwyn/logo.png',
    alt: 'ALLWYN influencers',
  },
  darkLogo: {
    src: '/themes/theme/allwyn/logo.png',
    alt: 'ALLWYN influencers',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'ALLWYN | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="70" src="/themes/theme/allwyn/logo.png" alt="ALLWYN Influencers" />
      <br />
    </div>
  ),
  shareSite: 'https://allwynr.dyzio.co',
};

export default AllwynTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/allwyn.js
 **/